// Mappings that drive the "Bill Other" / "Bill Other Submitter" answered-question values
// on the ServiceFormModal. Two sources of truth:
//   Doc 1: StarLIMS Test Panel Name (+ optional Specimen Source restriction)
//   Doc 2: Submitter facility (StarLIMS H-CODE)
// Submitter (doc 2) overrides panel/specimen (doc 1) when both match.

export interface PanelBillOtherRule {
  panelName: string;
  // Substrings matched (case-insensitive) against the specimen source label.
  // Undefined/empty means "All" specimen sources apply.
  specimenSources?: string[];
  billOtherSubmitterHCode: string;
}

// Doc 1 — panelName matches service.Name
export const PANEL_BILL_OTHER_MAP: PanelBillOtherRule[] = [
  { panelName: 'Haemophilus influenzae Identification', specimenSources: ['Blood', 'Whole Blood', 'Cerebrospinal fluid'], billOtherSubmitterHCode: 'SADISC' },
  { panelName: 'Listeria', billOtherSubmitterHCode: 'SADISC' },
  { panelName: 'mCIM', billOtherSubmitterHCode: 'FEE WAIVED' },
  { panelName: 'Neisseria ID', specimenSources: ['Whole Blood', 'Blood', 'Cerebrospinal fluid'], billOtherSubmitterHCode: 'SADISC' },
  { panelName: 'Salmonella PCR', billOtherSubmitterHCode: 'SADISC' },
  { panelName: 'Shiga Toxin', billOtherSubmitterHCode: 'SADISC' },
  { panelName: 'Shigella ID/serotyping', billOtherSubmitterHCode: 'SADISC' },
  { panelName: 'Vibrio Identification', billOtherSubmitterHCode: 'SADISC' },
];

// Doc 2 — key is facility.FacilityAbbreviation (Submitter StarLIMS H-CODE),
// value is Bill Other Submitter (H-CODE).
export const SUBMITTER_BILL_OTHER_MAP: Record<string, string> = {
  HMGCHC: 'MCOLBY',
  SAPHNA: 'SATBCO', // Augusta
  SAPHBG: 'SATBCO', // Bangor
  SAPHNC: 'SATBCO', // Calais
  SAPHCA: 'SATBCO', // Caribou
  SAPHNE: 'SATBCO', // Ellsworth
  SAPHFK: 'SATBCO', // Fort Kent
  SAPHNH: 'SATBCO', // Houlton
  SAPHNL: 'SATBCO', // Lewiston
  SAPHNM: 'SATBCO', // Machias
  SAPHNP: 'SATBCO', // Portland
  SAPHNR: 'SATBCO', // Rockland
  SAPHSA: 'SATBCO', // Sanford
  SAPHNS: 'SATBCO', // Skowhegan
};

export function getPanelBillOtherHCode(panelName?: string | null, specimenSourceName?: string | null): string | null {

  if (!panelName) return null;
  const match = PANEL_BILL_OTHER_MAP.find(e => e.panelName === panelName);
  
  if (!match) return null;
  if (match.specimenSources && match.specimenSources.length > 0) {
    if (!specimenSourceName) return null;
    const label = specimenSourceName.toLowerCase();
    const sourceMatches = match.specimenSources.some(s => label.includes(s.toLowerCase()));
    if (!sourceMatches) return null;
  }
  return match.billOtherSubmitterHCode;
}

export function getSubmitterBillOtherHCode(facilityAbbreviation?: string | null): string | null {
  if (!facilityAbbreviation) return null;
  return SUBMITTER_BILL_OTHER_MAP[facilityAbbreviation] ?? null;
}
